import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

const ETFChart = (props) => {
	const { data } = props;
	const [chartOptions, setChartOptions] = useState({});
	const { width } = useWindowSize();

	useEffect(() => {
		if (data && data.categories && data.series1 && data.series2) {
			const isMobile = width < 768;

			// 找出所有小時數和對應的索引
			const hourIndices = {};
			let minHour = 24;
			let maxHour = 0;

			data.categories.forEach((time, index) => {
				// 假設時間格式是 HH:mm:ss，提取小時部分
				const hour = parseInt(time.substring(0, 2), 10);

				// 記錄每個小時的第一個索引
				if (!hourIndices[hour] && hourIndices[hour] !== 0) {
					hourIndices[hour] = index;
				}

				// 更新最小和最大小時
				if (hour < minHour) minHour = hour;
				if (hour > maxHour) maxHour = hour;
			});

			setChartOptions({
				chart: {
					type: 'line',
					height: isMobile ? 212 : 386,
					style: {
						fontFamily: 'Arial, sans-serif'
					},
					marginBottom: isMobile ? 40 : 50,
					marginTop: isMobile ? 40 : 60,
					marginLeft: isMobile ? 30 : 46,
					marginRight: 0,  // 移除右側邊距
				},
				title: {
					text: ''
				},
				xAxis: {
					categories: data.categories,
					labels: {
						style: {
							color: '#666666',
							fontSize: `${isMobile ? 8 : 12}px`
						},
						formatter: function () {
							// 只顯示小時部分，例如 "09:00"
							return this.value.substring(0, 5);
						}
					},
					tickPositioner: function () {
						// 生成整點的刻度位置
						const positions = [];

						// 確保有足夠的刻度，即使數據很少
						if (data.categories.length <= 3) {
							// 如果數據點少於等於3個，就顯示所有點
							for (let i = 0; i < data.categories.length; i++) {
								positions.push(i);
							}
						} else {
							// 為每個小時生成刻度，即使沒有該小時的數據
							for (let hour = minHour; hour <= maxHour; hour++) {
								// 如果有這個小時的數據，使用其索引
								if (hourIndices[hour] !== undefined) {
									positions.push(hourIndices[hour]);
								} else {
									// 如果沒有這個小時的數據，估算一個位置
									// 找到前一個和後一個有數據的小時
									let prevHour = hour - 1;
									while (prevHour >= minHour && hourIndices[prevHour] === undefined) {
										prevHour--;
									}

									let nextHour = hour + 1;
									while (nextHour <= maxHour && hourIndices[nextHour] === undefined) {
										nextHour++;
									}

									// 如果找到了前後有數據的小時，估算中間小時的位置
									if (prevHour >= minHour && nextHour <= maxHour) {
										const prevIndex = hourIndices[prevHour];
										const nextIndex = hourIndices[nextHour];
										const ratio = (hour - prevHour) / (nextHour - prevHour);
										const estimatedIndex = Math.round(prevIndex + ratio * (nextIndex - prevIndex));

										// 確保估算的索引在有效範圍內
										if (estimatedIndex >= 0 && estimatedIndex < data.categories.length) {
											positions.push(estimatedIndex);
										}
									}
								}
							}
						}

						// 移除第一個標記
						if (positions.length > 0) {
							positions.shift();
						}

						return positions;
					},
					lineWidth: 1,
					tickWidth: 0,
					gridLineWidth: 0, // 拿掉縱向格線
					// startOnTick: true,
					// endOnTick: true
				},
				yAxis: {
					title: {
						text: ''
					},
					labels: {
						style: {
							color: '#666666',
							fontSize: `${isMobile ? 8 : 12}px`
						},
						formatter: function () {
							return this.value.toFixed(2);
						}
					},
					gridLineColor: '#E1E1E1',
					gridLineWidth: 1
				},
				tooltip: {
					formatter: function () {
						return `<b>${this.x}</b><br/>${this.series.name}: ${this.y.toFixed(2)}`;
					}
				},
				legend: {
					enabled: true, // 顯示圖例
					align: 'left',
					verticalAlign: 'top',
					layout: 'horizontal',
					x: isMobile ? 12 : 38,
					itemStyle: {
						fontSize: `${isMobile ? 8 : 12}px`,
						fontWeight: 'normal'
					},
					symbolWidth: 16,
					symbolHeight: 3,
					symbolRadius: 0
				},
				credits: {
					enabled: false
				},
				series: [{
					name: '預估淨值',
					data: data.series1,
					color: '#005EB8',
					lineWidth: 3,
					step: true,
					marker: {
						enabled: false
					}
				}, {
					name: '市價',
					data: data.series2,
					color: '#FB002C',
					lineWidth: 3,
					marker: {
						enabled: false
					}
				}],
				plotOptions: {
					series: {
						animation: {
							duration: 1000
						},
						states: {
							hover: {
								enabled: true,
								lineWidth: 3
							}
						}
					}
				}
			});
		}
	}, [data, width]);

	return (
		<HighchartsReact
			highcharts={Highcharts}
			options={chartOptions}
		/>
	);
}

export default ETFChart;
